<template>
  <div class="card none-border" style="background: transparent">
    <div class="card-body">
      <img src="@/assets/images/nodata.svg" alt width="100" class="mb-3" />

      <p>no data available!</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "nodata"
};
</script>